import { TagProps } from "@chakra-ui/react";
import { Task } from "features/Resources/Task/models";
import { blueStyles, errorStyles, grayStyles, greenStyles, orangeStyles } from "components/Tag/Status/styles";
import BaseActionStatus from "components/Tag/Status/BaseActionStatus";
import { relativeShortDate } from "helpers/time";
import { HorizontalGreyBlackField } from "components/DataDisplay/GreyBlackField";
import { longAttributeStyles } from "components/DataDisplay/styles";
import { toTaskStatusText } from "features/Resources/Task/helpers";

interface TaskStatusProps extends TagProps {
  status: Task["status"];
}

export function taskStatusStyles(status: Task["status"]) {
  switch (status) {
    case "completed":
      return greenStyles;
    case "failed":
      return errorStyles;
    case "skipped":
    case "closed_stale":
      return grayStyles;
    case "upcoming":
      return grayStyles;
    case "in_progress":
      return blueStyles;
    case "active":
      return blueStyles;
    case "blocked":
      return orangeStyles;
    case "":
    case "removed":
    default:
      return {};
  }
}

export function ShortTaskStatus({ status, ...rest }: TaskStatusProps) {
  if (["upcoming"].includes(status)) return null;
  return (
    <BaseActionStatus {...taskStatusStyles(status)} {...rest}>
      {toTaskStatusText(status)}
    </BaseActionStatus>
  );
}

export function FullTaskStatus({ status, ...rest }: TaskStatusProps) {
  if (status === "upcoming") return null;
  return (
    <BaseActionStatus {...taskStatusStyles(status)} {...rest}>
      {toTaskStatusText(status)}
    </BaseActionStatus>
  );
}

interface TaskStatusWithTimeProps extends TagProps {
  task: Task;
}

export function TaskStatusWithTime({ task, ...rest }: TaskStatusWithTimeProps) {
  if (!task) {
    return null;
  }
  if (task.status === "upcoming") return null;
  const statusText = toTaskStatusText(task?.status);
  let statusTimeText = relativeShortDate(task.startedAt);
  if (["skipped", "completed"].includes(task.status)) {
    statusTimeText = relativeShortDate(task?.statusUpdatedAt);
  }
  return (
    <BaseActionStatus {...taskStatusStyles(task.status)} {...rest}>
      {`${statusText} ${statusTimeText}`}
    </BaseActionStatus>
  );
}

export function ShowTaskStatus({ task, ...rest }: TaskStatusWithTimeProps) {
  return (
    <HorizontalGreyBlackField label="Status" labelContainerProps={longAttributeStyles.labelContainerProps}>
      <TaskStatusWithTime task={task} />
    </HorizontalGreyBlackField>
  );
}
